import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import messagesService from '../services/messagesService';

export const useConversationsQuery = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['conversations', params],
    queryFn: () => messagesService.getConversations(params),
    ...options,
  });
};

export const useConversationMessagesQuery = (conversationId, params = {}, options = {}) => {
  return useQuery({
    queryKey: ['messages', conversationId, params],
    queryFn: () => messagesService.getConversationMessages(conversationId, params),
    enabled: !!conversationId,
    ...options,
  });
};

export const useSendMessageMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ recipientId, text }) => messagesService.sendMessage(recipientId, text),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      if (data?.data?.conversationId) {
        queryClient.invalidateQueries({ queryKey: ['messages', data.data.conversationId] });
      }
    },
  });
};

export const useUnreadMessagesCountQuery = (options = {}) => {
  return useQuery({
    queryKey: ['messages', 'unreadCount'],
    queryFn: () => messagesService.getUnreadCount(),
    ...options,
  });
};

export const useMarkConversationReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (conversationId) => messagesService.markAsRead(conversationId),
    onSuccess: (data, conversationId) => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      queryClient.invalidateQueries({ queryKey: ['messages', conversationId] });
      queryClient.invalidateQueries({ queryKey: ['messages', 'unreadCount'] });
    },
  });
};
